import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { SettingsProvider } from "./context/SettingsContext";
import HomePage from "./components/HomePage";
import SignUp from "./components/signup/SignUp";
import UnderConstruction from "./components/UnderConstruction";
import LanguageSelectorHeader from "./components/layout/LanguageSelectorHeader";
import BottomNavigation from "./components/layout/BottomNavigation";
import ConversationListPage from "./pages/ConversationListPage";
import ConversationDetailPage from "./pages/ConversationDetailPage";
import GrammarLevelsPage from "./pages/GrammarLevelsPage";
import GrammarExercisePage from "./pages/GrammarExercisePage";
import ExerciseDiscussionPage from "./pages/ExerciseDiscussionPage";
import DictionaryPage from "./pages/DictionaryPage";
import ReviewPage from "./pages/ReviewPage";
import UserSettingsPage from "./pages/UserSettingsPage";
import WorldMapPage from "./pages/curriculum/WorldMapPage";
import WorldDetailPage from "./pages/curriculum/WorldDetailPage";
import LevelDetailPage from "./pages/curriculum/LevelDetailPage";
import ExerciseSessionPage from "./pages/curriculum/ExerciseSessionPage";


function App() {
  const EARLY_ACCESS: boolean = (process.env.REACT_APP_EARLY_ACCESS || "true").toLowerCase() === "true";

  return (
    <SettingsProvider>
      <LanguageProvider>
        <AppContent EARLY_ACCESS={EARLY_ACCESS} />
      </LanguageProvider>
    </SettingsProvider>
  );
}

function AppContent({ EARLY_ACCESS }: { EARLY_ACCESS: boolean }) {
  const location = useLocation();
  
  // Show header and navigation only on authenticated pages
  const showLayout = !["/", "/signup"].includes(location.pathname);

  return (
    <div className="App min-h-dvh bg-base-100">
      {showLayout && <LanguageSelectorHeader />}
      
      <div className={showLayout ? "h-dvh" : "min-h-dvh content-center text-center"}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/signup" element={EARLY_ACCESS ? <UnderConstruction /> : <SignUp />} />
          
          {/* Redirect old routes */}
          <Route path="/chat" element={<Navigate to="/conversations" replace />} />
          <Route path="/grammar-practice" element={<Navigate to="/grammar" replace />} />
          
          {/* New authenticated routes */}
          <Route path="/conversations" element={<ConversationListPage />} />
          <Route path="/conversations/:conversationId" element={<ConversationDetailPage />} />
          <Route path="/grammar" element={<GrammarLevelsPage />} />
          <Route path="/grammar/practice" element={<GrammarExercisePage />} />
          <Route path="/grammar/exercise/:exerciseId/discussion" element={<ExerciseDiscussionPage />} />
          <Route path="/dictionary" element={<DictionaryPage />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/settings" element={<UserSettingsPage />} />
          
          {/* Curriculum routes */}
          <Route path="/learn" element={<WorldMapPage />} />
          <Route path="/learn/world/:worldId" element={<WorldDetailPage />} />
          <Route path="/learn/level/:levelId" element={<LevelDetailPage />} />
          <Route path="/learn/exercise/:exerciseId" element={<ExerciseSessionPage />} />
          
          {/* Catch all - redirect to conversations */}
          <Route path="*" element={<Navigate to="/conversations" replace />} />
        </Routes>
      </div>
      
      {showLayout && <BottomNavigation />}
    </div>
  );
}

export default App;
